const franchiseSalesTest = {
  displayField: 'franchisetitle',
  name: 'Franchise Sales test',
  description: 'this is a test page for franchise sales',
  fields: [
    {
      id: 'franchisetitle',
      name: 'Title',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'franchiseSalesTest',
    version: 2,
    updatedAt: '2024-04-23T16:59:45.730Z'
  }
};
export default franchiseSalesTest;